"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageNode = void 0;
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var slate_1 = require("slate");
var isImageNode = function (elem) {
    return slate_1.Element.isElement(elem) && elem.type === Models_1.BlockType.Image;
};
exports.isImageNode = isImageNode;
